import { CommonEnums } from '../../common.enums';
import { Flagent_cfg } from './flagent_cfg';
import { Flagent_cfgsUtil } from '../../utils/flagent_cfgs.util';

export class Fla_Fldr {
	flagent_Id: number;
	fldr_Id: number;
	reusableFlag: string;
	fldr_Nm: string;
	flagentNm: string;
	agentGrpInd: string;

	flagent_cfgs: Array<Flagent_cfg>;
	cfgChangeInd: string;

	constructor() {
		this.setDefaults()
	}

	setDefaults(): void {
		this.flagent_Id = CommonEnums.defaults.LONG_VAL;
		this.fldr_Id = CommonEnums.defaults.LONG_VAL;
		this.reusableFlag = CommonEnums.reusableFlag.NO;
		this.fldr_Nm = CommonEnums.defaults.STRING_EMPTY;
		this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
		this.agentGrpInd = CommonEnums.defaults.STRING_EMPTY;
		this.flagent_cfgs = new Array<Flagent_cfg>();
		this.cfgChangeInd = CommonEnums.defaults.STRING_VAL_NO;
	}

	static parse(object: any): Fla_Fldr {
        let fla_Fldr: Fla_Fldr = new Fla_Fldr();
        fla_Fldr.copyFrom(object as Fla_Fldr);
        return fla_Fldr;
    }

	copy(): Fla_Fldr {
		let fla_FldrTmp: Fla_Fldr = new Fla_Fldr();

		fla_FldrTmp.flagent_Id = this.flagent_Id;
		fla_FldrTmp.fldr_Id = this.fldr_Id;
		fla_FldrTmp.reusableFlag = this.reusableFlag;
		fla_FldrTmp.fldr_Nm = this.fldr_Nm;
		fla_FldrTmp.flagentNm = this.flagentNm;
		fla_FldrTmp.agentGrpInd = this.agentGrpInd;
		fla_FldrTmp.flagent_cfgs = Flagent_cfgsUtil.getInstance().copy(this.flagent_cfgs);
		fla_FldrTmp.cfgChangeInd = this.cfgChangeInd;

		return fla_FldrTmp;
	}

	copyFrom(fla_FldrTmp: Fla_Fldr): void {
		this.flagent_Id = fla_FldrTmp.flagent_Id;
		this.fldr_Id = fla_FldrTmp.fldr_Id;
		this.reusableFlag = fla_FldrTmp.reusableFlag;
		this.fldr_Nm = fla_FldrTmp.fldr_Nm;
		this.flagentNm = fla_FldrTmp.flagentNm;
		this.agentGrpInd = fla_FldrTmp.agentGrpInd;

		Flagent_cfgsUtil.getInstance().copyFrom(this.flagent_cfgs, fla_FldrTmp.flagent_cfgs);
		this.cfgChangeInd = fla_FldrTmp.cfgChangeInd;
	}

	compare(fla_FldrTmp: Fla_Fldr): string {
		let fla_FldrString: string = this.toString(false);
		let fla_FldrTmpString: string = fla_FldrTmp.toString(false);

		if (fla_FldrString != fla_FldrTmpString) {
			return fla_FldrString + ', ' + fla_FldrTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "Fla_Fldr [flagent_Id=" + this.flagent_Id + ", fldr_Id=" + this.fldr_Id;

		if (isNotCompare) {
			str += ", reusableFlag=" + this.reusableFlag + ", fldr_Nm=" + this.fldr_Nm +
				", flagentNm=" + this.flagentNm + ", agentGrpInd=" + this.agentGrpInd +
				", flagent_cfgs=" + Flagent_cfgsUtil.getInstance().toString(this.flagent_cfgs) +
				", cfgChangeInd=" + this.cfgChangeInd;
		}

		str += ']';

		return str;
	}
}